import { Flex, Spin } from 'antd'
import { Cluster, Grade, SearchResult } from 'src/types/type'

import { Collapse, Tag } from '@suntex.fim/ui'

import { handleEnterOrSpacePress } from '../LearningCenter/util'

interface SuggestContentSidebarProps {
  filteredResults: SearchResult[]
  grade: string | string[]
  selectedCluster: Cluster | null
  onChangeGrade: (key: string | string[]) => void
  handleClusterClick: (cluster: Cluster) => void
  searchQuery: string
  checkedModulesAndClusters: {
    [key: string]: boolean
  }
}

function getCountOfCheckedItemsByGrade(obj: { [key: string]: boolean }): {
  [grade: string]: number
} {
  const gradeCounts: { [grade: string]: number } = {}

  // Iterate over each key in the object using forEach
  Object.keys(obj).forEach((key) => {
    // Extract the grade (the first character before the dash)
    const grade = key.split('-')[0]

    // If the value is true, increment the count for the grade
    if (obj[key] === true) {
      if (!gradeCounts[grade]) {
        gradeCounts[grade] = 1
      } else {
        gradeCounts[grade] += 1
      }
    }
  })

  return gradeCounts
}

export function getIndividualCount(
  obj: { [key: string]: number },
  grade: string
): number {
  // Return the value if the grade exists in the object, otherwise return undefined
  return obj[grade]
}

function RenderGradeContent({
  grade,
  onChangeGrade,
  filteredResults,
  handleClusterClick,
  selectedCluster,
  searchQuery,
  checkedModulesAndClusters
}: SuggestContentSidebarProps) {
  const countOfGrade = getCountOfCheckedItemsByGrade(checkedModulesAndClusters)
  return (
    <div className="suggest-content__sidebar-grade-group">
      {searchQuery.length === 0 && filteredResults.length === 0 ? (
        <Spin />
      ) : filteredResults.length === 0 ? (
        <p>No results found.</p>
      ) : (
        <Collapse
          accordion
          activeKey={[`${grade}`]}
          className="suntex-collapse--suggest-content"
          panels={(filteredResults as Grade[]).map((gradeData) => {
            const count =
              getIndividualCount(countOfGrade, String(gradeData.grade)) || 0
            return {
              key: String(gradeData.grade),
              header: (
                <Flex
                  justify="space-between"
                  align="center"
                  aria-label="Expand Grade ${gradeData.grade} clusters"
                >
                  <span>{`Grade ${gradeData.grade}`}</span>
                  {count > 0 && (
                    <Tag label={count} className="suggest-content-tag" />
                  )}
                </Flex>
              ),
              content: (
                <ul className="collapse-submenu">
                  {gradeData.clusters.map((cluster: Cluster) => (
                    <button
                      key={String(cluster.name)}
                      type="button"
                      className={`collapse-submenu-items ${
                        selectedCluster?.name === cluster.name ? 'active' : ''
                      } hover-underline-link`}
                      onClick={() => handleClusterClick(cluster)}
                      aria-label={`Select cluster ${cluster.name}`}
                      tabIndex={0}
                      onKeyDown={(e) =>
                        handleEnterOrSpacePress(e, () =>
                          handleClusterClick(cluster)
                        )
                      }
                    >
                      {cluster.name}
                    </button>
                  ))}
                </ul>
              )
            }
          })}
          onChange={onChangeGrade}
        />
      )}
    </div>
  )
}

export default RenderGradeContent
